function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var Workbook = /*#__PURE__*/function () {
  function Workbook(workbook) {
    _classCallCheck(this, Workbook);

    Object.defineProperties(this, {
      _: {
        value: workbook
      },
      sheetNames: {
        value: workbook.worksheets.map(function (s) {
          return s.name;
        }),
        enumerable: true
      }
    });
  }

  _createClass(Workbook, [{
    key: "sheet",
    value: function sheet(name, options) {
      var sname = typeof name === "number" ? this.sheetNames[name] : this.sheetNames.includes(name += "") ? name : null;
      if (sname == null) throw new Error("Sheet not found: ".concat(name));

      var sheet = this._.getWorksheet(sname);

      return extract(sheet, options);
    }
  }]);

  return Workbook;
}();

function extract(sheet) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      range = _ref.range,
      headers = _ref.headers;

  var _parseRange = parseRange(range, sheet),
      _parseRange2 = _slicedToArray(_parseRange, 2),
      _parseRange2$ = _slicedToArray(_parseRange2[0], 2),
      c0 = _parseRange2$[0],
      r0 = _parseRange2$[1],
      _parseRange2$2 = _slicedToArray(_parseRange2[1], 2),
      c1 = _parseRange2$2[0],
      r1 = _parseRange2$2[1];

  var headerRow = headers ? sheet._rows[r0++] : null;
  var names = new Set(["#"]);

  for (var n = c0; n <= c1; n++) {
    var value = headerRow ? valueOf(headerRow.findCell(n + 1)) : null;
    var name = value && value + "" || toColumn(n);

    while (names.has(name)) {
      name += "_";
    }

    names.add(name);
  }

  names = new Array(c0).concat(Array.from(names));
  var output = new Array(r1 - r0 + 1);

  for (var r = r0; r <= r1; r++) {
    var row = output[r - r0] = Object.create(null, {
      "#": {
        value: r + 1
      }
    });

    var _row = sheet.getRow(r + 1);

    if (_row.hasValues) for (var c = c0; c <= c1; c++) {
      var _value = valueOf(_row.findCell(c + 1));

      if (_value != null) row[names[c + 1]] = _value;
    }
  }

  output.columns = names.filter(function () {
    return true;
  }); // Filter sparse columns

  return output;
}

function valueOf(cell) {
  if (!cell) return;
  var value = cell.value;

  if (value && _typeof(value) === "object" && !(value instanceof Date)) {
    if (value.formula || value.sharedFormula) {
      return value.result && value.result.error ? NaN : value.result;
    }

    if (value.richText) {
      return richText(value);
    }

    if (value.text) {
      var text = value.text;
      if (text.richText) text = richText(text);
      return value.hyperlink && value.hyperlink !== text ? "".concat(value.hyperlink, " ").concat(text) : text;
    }

    return value;
  }

  return value;
}

function richText(value) {
  return value.richText.map(function (d) {
    return d.text;
  }).join("");
}

function parseRange() {
  var specifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ":";

  var _ref2 = arguments.length > 1 ? arguments[1] : undefined,
      columnCount = _ref2.columnCount,
      rowCount = _ref2.rowCount;

  specifier += "";
  if (!specifier.match(/^[A-Z]*\d*:[A-Z]*\d*$/)) throw new Error("Malformed range specifier");

  var _specifier$split$map = specifier.split(":").map(fromCellReference),
      _specifier$split$map2 = _slicedToArray(_specifier$split$map, 2),
      _specifier$split$map3 = _slicedToArray(_specifier$split$map2[0], 2),
      _specifier$split$map4 = _specifier$split$map3[0],
      c0 = _specifier$split$map4 === void 0 ? 0 : _specifier$split$map4,
      _specifier$split$map5 = _specifier$split$map3[1],
      r0 = _specifier$split$map5 === void 0 ? 0 : _specifier$split$map5,
      _specifier$split$map6 = _slicedToArray(_specifier$split$map2[1], 2),
      _specifier$split$map7 = _specifier$split$map6[0],
      c1 = _specifier$split$map7 === void 0 ? columnCount - 1 : _specifier$split$map7,
      _specifier$split$map8 = _specifier$split$map6[1],
      r1 = _specifier$split$map8 === void 0 ? rowCount - 1 : _specifier$split$map8;

  return [[c0, r0], [c1, r1]];
} // Returns the default column name for a zero-based column index.
// For example: 0 -> "A", 1 -> "B", 25 -> "Z", 26 -> "AA", 27 -> "AB".


function toColumn(c) {
  var sc = "";
  c++;

  do {
    sc = String.fromCharCode(64 + (c % 26 || 26)) + sc;
  } while (c = Math.floor((c - 1) / 26));

  return sc;
} // Returns the zero-based indexes from a cell reference.
// For example: "A1" -> [0, 0], "B2" -> [1, 1], "AA10" -> [26, 9].


function fromCellReference(s) {
  var _s$match = s.match(/^([A-Z]*)(\d*)$/),
      _s$match2 = _slicedToArray(_s$match, 3),
      sc = _s$match2[1],
      sr = _s$match2[2];

  var c = 0;
  if (sc) for (var i = 0; i < sc.length; i++) {
    c += Math.pow(26, sc.length - i - 1) * (sc.charCodeAt(i) - 64);
  }
  return [c ? c - 1 : undefined, sr ? +sr - 1 : undefined];
}